import {Size} from "../../base/data/size";

export abstract class AbstractFormConfig {

  public size: Size | undefined;
  public btnMinWidth: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 20 | 30 | 40 | undefined = undefined;
  public btnClass: string | undefined = undefined;
  public showCopyClipboard: boolean = false;

  protected constructor(init?: Partial<AbstractFormConfig> | undefined) {
    Object.assign(this, init);
  }
}
